import React from "react"
import ProductModelBase from "theme/base/shop/ProductModel"
import { Icon, Label } from "semantic-ui-react"

export default class ProductModel extends ProductModelBase {
  
  constructor( data ) {
    super( data );
  }
  
  
  getNotice = ( size ) => {
    let product = this
    
    const categoryName = this.category && this.category.desc && this.category.desc.short_des.trim()
    
    const yellow = {}
    const red = {}
    
    const default_yellow = 3
    const default_red = 0
    
    // check special conditions
    const yellowCount = yellow[ categoryName ] || default_yellow || 0
    const redCount = red[ categoryName ] || default_red || 0
    
    const stock = this.stock
    
    const deliveryDate = this.extras.liefab
    
    if ( size === "tiny" ) {
      if ( deliveryDate ) {
        return notice = <Icon name={"truck"} color="blue" title={`${translate( "Lieferbar ab:" )} ${deliveryDate}`} className={"avail-date"}/>
      }
      
      if ( stock <= redCount ) {
        return notice =
          <span className={"avail-none"}><Icon color="red" name="truck" title={`${translate( "derzeit nicht lieferbar - bald wieder verfügbar" )}`}/></span>
      }
      
      if ( stock <= yellowCount ) {
        return notice = <span className={"avail-danger"}><Icon color="yellow" name="truck" title={`${translate( "wenig auf Lager" )}`}/></span>
      }
      
      if ( stock > yellowCount ) {
        return notice = <span className={"black-70   ttu"}><Icon color="green" name="truck" title={translate( "auf Lager" )}/></span>
      }
    }
    
    if ( deliveryDate ) {
      return notice = <Label color="blue" className={"avail-date"}><Icon name="truck" title={`${translate( "Lieferbar ab:" )} ${deliveryDate}`}/>{`${translate( "Lieferbar ab:" )} ${deliveryDate}`}</Label>
    }
    
    if ( stock <= redCount ) {
      return notice = <span className={"avail-none"}><Icon color="red" name="truck" title={`nicht auf Lager`}/> {translate( "derzeit nicht lieferbar - bald wieder verfügbar" )}</span>
    }
    
    if ( stock <= yellowCount ) {
      return notice = <span className={"avail-danger"}><Icon color="yellow" name="truck" title={`wenig auf Lager`}/>{translate( "wenig auf Lager" )}</span>
    }
    
    if ( stock > yellowCount ) {
      return notice = <span className={"black-70   ttu"}><Icon color="green" name="truck" title="auf Lager"/> {translate( "auf Lager" )}</span>
    }
    
    let notice = <span className={"avail-none"}><Icon color="red" name="truck" title="Nicht verfügbar" circular/><span>{translate( "derzeit nicht lieferbar - bald wieder verfügbar" )}</span></span>
    
    if ( stock ) {
      return notice = <span className={"black-70   ttu"}><Icon title="Auf Lager" name="truck" circular color="green"/>{translate( "auf Lager" )}</span>
    }
    
    return notice
  }
}



// WEBPACK FOOTER //
// ./src/theme/giraffiti/shop/ProductModel.js